import React from 'react';
import './modal.css';
import InternalPhoto from '../InternalPhoto';

const getInitials = (name) => {
  const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  return ((parts[0][0] || '') + (parts.length > 1 ? parts[parts.length - 1][0] : '')).toUpperCase();
};

const ConfirmationModal = ({
  isOpen,
  message,
  internals,
  onSelectInternal,
  onConfirm,
  onClose,
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  getInternalDisabledReason,
}) => {
  if (!isOpen) return null;

  const getStatusColor = (status) => {
    if (status === 'Preso') return 'red-text';
    if (status === 'Fugitivo') return 'orange-text';
    if (status === 'Liberado') return 'green-text';
    if (status === 'Monitorado') return 'blue-text';
    if (status === 'Saída Temporária' || status === 'Saida Temporaria') return 'purple-text';
    return '';
  };

  const handleOverlayClick = (e) => {
    // Verifica se o clique foi na própria sobreposição (fora do modal)
    if (e.target.classList.contains('confirmationmodal-overlay')) {
      onClose();
    }
  };

  return (
    <div className="confirmationmodal-overlay" onClick={handleOverlayClick}>
      <div className="confirmationmodal-container">
        <div className="confirmationmodal-content">
          <h2>{message}</h2>
          {internals && (
            <div className="internal-item-list">
              {internals.map((internal) => {
                const disabledReason = typeof getInternalDisabledReason === 'function'
                  ? getInternalDisabledReason(internal)
                  : '';
                const isDisabled = Boolean(disabledReason);
                return (
                  <div
                    key={internal.id}
                    className={`internal-item${isDisabled ? ' is-disabled' : ''}`}
                    onClick={isDisabled ? undefined : () => onSelectInternal(internal)}
                  >
                    <InternalPhoto internal={internal} preferThumbnail alt="" className="internal-item-photo">
                      <span className="internal-item-photo internal-item-photo--placeholder">
                        {getInitials(internal.name)}
                      </span>
                    </InternalPhoto>
                    <div className="internal-item-info">
                      <p className="internal-item-name">{internal.name}</p>
                      <span className={`internal-item-status ${getStatusColor(internal.status?.name)}`}>
                        {internal.status?.name}
                      </span>
                      {isDisabled && <span className="internal-item-blocked">{disabledReason}</span>}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
        {onConfirm && (
          <div className="confirmationmodal-actions">
            <button className="btn-cancel" onClick={onClose}>
              {cancelLabel}
            </button>
            <button className="btn-confirm" onClick={onConfirm}>
              {confirmLabel}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ConfirmationModal;
